// extracted by mini-css-extract-plugin
export default {"details":"PickupAddressSidebar_details__68B2V","title":"PickupAddressSidebar_title__7OU_8"};